import { Component } from 'react';
import './Footer.scss';

class Footer extends Component {
	constructor() {
		super();

		this.state = {};
	}

	render() {
		return <div className='footer'></div>;
	}
}

export default Footer;
